import SlideOverBody from './component/body';
import SlideOverFooter from './component/footer';
import SlideOverHeader from './component/header';
import SlideOverTabs from './component/tabs';

/**
 * A side panel of the admin, as the task panel draws it: its header (`title`,
 * `description` under it, `headerActions` and `navigation` before the cross
 * that calls `onClose`), its tabs when it has some (`tabs`, `activeTab`,
 * `onTabChange`, `tabsVariant` for their look, and `tabsAside` on their line, placed by the caller), its
 * body (`children`, `bodyClassName`), what stays under the body while it
 * scrolls (`belowBody`: the comment field of a task) and its footer (`footer`,
 * under a line).
 * Every panel takes this layout rather than putting the pieces together again.
 */
const SlidePanel = ({
  title,
  description,
  onClose,
  closeLabel,
  hideClose = false,
  headerActions,
  navigation,
  tabs,
  activeTab,
  onTabChange,
  tabsVariant,
  tabsAside,
  bodyClassName,
  belowBody,
  footer,
  children,
}) => (
  <>
    <SlideOverHeader
      hide={onClose}
      hideShow={!hideClose}
      closeLabel={closeLabel}
      description={description}
      extraActions={headerActions}
      navigation={navigation}
    >
      {title}
    </SlideOverHeader>
    {tabs && (
      <SlideOverTabs tabs={tabs} activeTab={activeTab} onChange={onTabChange} variant={tabsVariant}>
        {tabsAside}
      </SlideOverTabs>
    )}
    <SlideOverBody className={bodyClassName}>{children}</SlideOverBody>
    {belowBody && <div className="flex-shrink-0 border-t border-gray-100 px-6 py-4">{belowBody}</div>}
    {footer && (
      <div className="flex-shrink-0 border-t border-gray-100">
        <SlideOverFooter>{footer}</SlideOverFooter>
      </div>
    )}
  </>
);

export default SlidePanel;
